const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoMunicipal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01,12.3c-.59.59-1.57.59-2.17,0l2.56-2.55c-.04-.2-.13-.41-.28-.57l-1.8,1.79-1.31,1.31s-.02.02-.02.02c-.59.59-1.57.59-2.17,0l2.56-2.57c-.04-.2-.13-.41-.28-.57l-3.13,3.12s-.02.02-.02.02c-.26.28-.61.42-.96.44,1,1.09,2.44,1.75,4.06,1.75,2.78,0,5.06-2.03,5.46-4.69l-2.48,2.47-.02.02ZM8.81,8.43s.08.02.13.04t.06.02s.03.01.06.03c.03.01.05.03.05.03t.07.05s.02.02.04.03c.02.02.06.04.07.06t.04.04s.07.06.11.09c.15.15.26.33.33.52l.52-.52c.35-.35.83-.5,1.3-.42t.06.01h.04s.08.02.11.02t.04,0c.05.01.09.02.13.03.02,0,.02.02.04.02.04.02.06.02.09.04.02,0,.04.02.04.02.03.02.03.02.07.04.02.02.01.01.04.03.02.02.06.04.07.06t.04.04s.07.06.11.09c.15.15.26.33.33.52l.52-.52c.31-.31.76-.46,1.17-.44-.26-2.71-2.61-4.84-5.44-4.84-3.04,0-5.52,2.47-5.52,5.5,0,1.03.28,1.99.78,2.81l3-2.99c.35-.35.83-.5,1.3-.42",
    style: {
      fill: "#e30613"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoMunicipal);
export default __webpack_public_path__ + "static/media/banco-municipal.72c5777305482d0e55cbb3657ee4864b.svg";
export { ForwardRef as ReactComponent };